import { currentMonthKey, moveMonthKey } from './dateTime';

export const MONTH_OPTIONS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
].map((label, index) => ({ label, value: String(index + 1).padStart(2, '0') }));

export const isValidYear = (year) => /^[1-9]\d{3}$/.test(year);

export const sanitizeYear = (year) => String(year || '').replace(/\D/g, '').slice(0, 4);

export const monthKeyFromSelection = (year, month) => (
  isValidYear(year) && /^(0[1-9]|1[0-2])$/.test(month) ? `${year}-${month}` : ''
);

export const initialMonthSelection = (search = '') => {
  const urlMonth = new URLSearchParams(search).get('month');
  const monthKey = /^([1-9]\d{3})-(0[1-9]|1[0-2])$/.test(urlMonth || '')
    ? urlMonth
    : currentMonthKey();
  const [year, month] = monthKey.split('-');
  return { year, month };
};

export const moveMonthSelection = (year, month, amount) => {
  const monthKey = monthKeyFromSelection(year, month);
  if (!monthKey) return null;
  const [nextYear, nextMonth] = moveMonthKey(monthKey, amount).split('-');
  return { year: nextYear, month: nextMonth };
};
